// AD-2777: before the go-live choices on a form that is not live, the form is saved when its contents changed or when
// only its Access settings changed. Previously an Access-only change (such as 'Allow other School Admins to change
// these Access settings') was not saved, although 'Your form has been saved' was shown.
export const needsSaveBeforeGoLive = (hasUnsavedChanges, accessHasChanges) =>
    Boolean(hasUnsavedChanges) || Boolean(accessHasChanges);
